/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const role = currentUser?.role;
  // 问卷模拟专用账号：只能看到问卷模拟模块
  const isSimulationOnlyAccount = currentUser?.phone === '18888888888';

  return {
    canAdmin: !isSimulationOnlyAccount && (role === 'admin' || role === 'civil_admin'),
    // 明确排除 civil_admin 对 AI统计 和 图片同步 的访问权限
    canAccessAIStats: !isSimulationOnlyAccount && role === 'admin' && (role as string) !== 'civil_admin',
    canAccessImageSync: !isSimulationOnlyAccount && role === 'admin' && (role as string) !== 'civil_admin',
    // 问卷模拟模块仅指定账号可见
    canAccessSimulation: isSimulationOnlyAccount,
    // 问卷模拟专用账号隐藏其他所有菜单
    canAccessOtherMenus: !isSimulationOnlyAccount,
  };
}